import { Dropdown } from '@linktivity/link-ui';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './layoutUser.module.css';

interface LayoutUserProps {
  email: string;
  onLogout: () => void;
}

const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className={styles.icon}>
    <rect width="256" height="256" fill="none" />
    <circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
    <circle cx="128" cy="120" r="40" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
    <path d="M63.8,199.4a72,72,0,0,1,128.4,0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
  </svg>
);

const LayoutUser: React.FC<LayoutUserProps> = ({ email, onLogout }) => {
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);

  const userButton = useMemo(
    () => (
      <button
        className={styles.button}
        type="button"
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <UserIcon />
        <span className={styles.text}>{t('common.account')}</span>
      </button>
    ),
    [t]
  );

  const handleLogout = useCallback(() => {
    setOpenMenu(false);
    onLogout();
  }, [onLogout]);

  return (
    <Dropdown
      target={userButton}
      visible={openMenu}
      sameWidth={false}
      placement="bottom-end"
      onClose={() => setOpenMenu(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item>
          <button className={styles.dropdownButton}>
            <p className={styles.dropdownText}>{email}</p>
          </button>
        </Dropdown.Item>
        <Dropdown.Item>
          <button className={styles.dropdownButton} onClick={handleLogout}>
            {t('common.logout')}
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LayoutUser;
